import { SEND_UPDATE } from '../../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case SEND_UPDATE.LOAD:
      return {
        ...state,
        loading: true,
      };
    case SEND_UPDATE.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case SEND_UPDATE.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
